import 'src/polyfills';

import { createRoot } from 'react-dom/client';

import { installChunkLoadRecovery } from './chunk-load-recovery';
import { renderClientRoot } from './client-root';

installChunkLoadRecovery();

const container = document.getElementById('root');
if (!container) throw new Error('Root element not found');

const root = createRoot(container);
void renderClientRoot(root);
